<template>
  <div class='frameworks'>
    <section class="framework" v-if="data">
      <div class="framework__data">
        <trend-chart :datasets="[dataset]" :min="0" padding="0 1 0" :interactive="true" @mouse-move="onMouseMove"></trend-chart>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ['data', 'currentInfo'],
  computed: {
    weeklyDownloads() {
      return this.numberWithSpaces(this.data.reduce((a, c) => a + c.value, 0));
    },
    dataset() {
      return {
        data: this.data,
        showPoints: true,
        fill: true,
        className: `curve`
      };
    },
    info() {
      return {
        label: this.currentInfo.label ? this.currentInfo.label : "Watches",
        value: this.currentInfo.label ? this.currentInfo.value : this.weeklyDownloads
      };
    }
  },
  methods: {
    numberWithSpaces(n) {
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    onMouseMove(params) {
      if (!params) {
        this.currentInfo.label = null
        this.currentInfo.value = null
        return
      }

      if (params.data[0]) {
        this.currentInfo.label = params.data[0].day
        this.currentInfo.value = this.numberWithSpaces(params.data[0].value)
      }
    }
  }
}
</script>

<style lang='scss'>
.frameworks {
  display: flex;
  flex-wrap: wrap;
  .vtc {
    width: 160px;
    width: 100%;
    height: 60px;
    margin-right: -5px;
  }
  .stroke {
    stroke-width: 2;
  }
  .fill {
    opacity: 0.2;
  }
  .active-line {
    stroke: rgba(0, 0, 0, 0.2);
  }
  .point {
    display: none;
  }
  .point.is-active {
    display: block;
  }
}
.framework {
  width: 100%;

  &__data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
}
.curve {
  .stroke {
    stroke: #2b5eff;
  }
  .fill {
    fill: #2b5eff;
  }
  .point {
    fill: #2b5eff;
    stroke: #2b5eff;
  }
}
</style>
